import { ProcessingDataInfo } from '../models/interface/processingDataInfo.interface';

/**
 * Processing Data
 */
export class ProcessingData<T> {
  private info: ProcessingDataInfo<T>;
  private quantity: number;
  private processed: number;
  private error: string;

  errorData: any = {};
  mode = 'indeterminate';

  constructor(definition: ProcessingDataInfo<T>) {
    this.info = { ...definition };
    this.quantity = this.info.quantity;
    this.processed = this.info.processed;
    this.error = this.info.errorMessage;
  }

  get flags() {
    return this.info.flags;
  }

  get showFlag() {
    return this.info.showFlag;
  }

  get showState() {
    return this.info.flags.get(this.info.showFlag);
  }

  get errorState() {
    return this.info.flags.get(this.info.errorFlag);
  }

  get title() {
    return this.info.title;
  }

  get message() {
    return this.info.message;
  }

  get errorTitle() {
    return this.info.errorTitle;
  }

  get errorMessage() {
    return this.error;
  }

  get value() {
    if (this.mode === 'indeterminate') {
      return null;
    }
    return Math.round((this.processed / this.quantity) * 10000) / 100;
  }

  begin() {
    this.error = null;
    this.quantity = 0;
    this.processed = 0;
    this.mode = 'indeterminate';
    this.info.flags.enable(this.info.showFlag);
  }

  init(quantity: number) {
    if (quantity !== 0) {
      this.quantity = quantity;
    }
  }

  markError(message: string, errorData: any = {}) {
    this.error = message;
    this.errorData = errorData;
    this.info.flags.enable(this.info.errorFlag);
  }

  updateProgress(processed: number) {
    this.processed += processed;
    if (processed > 0) {
      this.mode = 'determinate';
    }
  }

  setProgress(processed: number) {
    this.processed = processed;
    if (processed > 0) {
      this.mode = 'determinate';
    }
  }

  end() {
    this.info.flags.disable(this.info.showFlag);
    this.info.flags.disable(this.info.errorFlag);
  }
}
